"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespacedClassnames = exports.namespaceClassName = void 0;
var answers_lib_1 = require("@wix/answers-lib");
exports.namespaceClassName = 'aul';
exports.namespacedClassnames = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return answers_lib_1.classNames(exports.namespaceClassName, args);
};
//# sourceMappingURL=namespace-classes.js.map